import { useViewportSize as useMantineViewportSize } from '@mantine/hooks';
import { useMemo } from 'react';

interface ViewportInfo {
  width: number;
  height: number;
  safeAreaTop: number;
  safeAreaBottom: number;
  availableHeight: number;
  isLandscape: boolean;
}

export function useViewportSize(): ViewportInfo {
  const { width, height } = useMantineViewportSize();
  
  const viewportInfo = useMemo(() => {
    // Estimate safe areas for mobile devices (can be refined with env() CSS variables)
    const isMobile = width <= 768;
    const safeAreaTop = isMobile ? 20 : 0; // Status bar estimate
    const safeAreaBottom = isMobile ? 20 : 0; // Home indicator estimate
    
    return {
      width,
      height,
      safeAreaTop,
      safeAreaBottom,
      availableHeight: height - safeAreaTop - safeAreaBottom,
      isLandscape: width > height
    };
  }, [width, height]);
  
  return viewportInfo;
}